import { render, staticRenderFns } from "./Reviewed.vue?vue&type=template&id=750defd4&scoped=true"
import script from "./Reviewed.vue?vue&type=script&lang=js"
export * from "./Reviewed.vue?vue&type=script&lang=js"
import style0 from "./Reviewed.vue?vue&type=style&index=0&id=750defd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750defd4",
  null
  
)

export default component.exports